import React, { FunctionComponent } from 'react';
import { useDispatch } from 'react-redux';
import { ButtonBase, Container, Stack, Typography } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';

import { toggleAdminEditModel } from '../../../store/ConfigSlice';

const NoEditModePageView: FunctionComponent = () => {
  const dispatch = useDispatch();

  return (
    <Container maxWidth="xl">
      <Stack padding="30px" textAlign="center" gap="20px" alignItems="center">
        <LockIcon sx={{ fontSize: '80px', color: 'primary.main' }} />
        <Typography variant="h4">You are not in edit mode</Typography>
        <Typography variant="h6">
          Do you want to turn on the edit mode?&nbsp;
          <ButtonBase
            onClick={() => dispatch(toggleAdminEditModel())}
            sx={{
              fontSize: 'inherit',
              fontWeight: 'inherit',
              color: 'primary.main',
            }}
          >
            <b>Turn on </b>
          </ButtonBase>
        </Typography>
      </Stack>
    </Container>
  );
};

export default NoEditModePageView;
